export default __webpack_public_path__ + "static/media/pn.c568083a.svg";